// API base URL comes from the runtime config file public/config.js
// (window.PROTRACK_CONFIG.apiUrl), never from the compiled bundle -- each
// deployment serves its own copy. Local dev always talks to localhost:8000.
const configuredApiUrl = String(window.PROTRACK_CONFIG?.apiUrl || "").trim().replace(/\/+$/, "");

if (window.location.hostname !== "localhost" && !configuredApiUrl) {
  // eslint-disable-next-line no-console
  console.error("ProTrack: apiUrl is not set in config.js; API calls will go to this site's own origin.");
}

export const API =
  window.location.hostname === "localhost"
    ? "http://localhost:8000"
    : configuredApiUrl;

const TTL_MS = 30 * 60 * 1000; // 30 minutes

export function getCached(key) {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    const { data, ts } = JSON.parse(raw);
    if (Date.now() - ts > TTL_MS) {
      sessionStorage.removeItem(key);
      return null;
    }
    return data;
  } catch {
    sessionStorage.removeItem(key);
    return null;
  }
}

export function setCached(key, data) {
  sessionStorage.setItem(key, JSON.stringify({ data, ts: Date.now() }));
}

export function removeCached(key) {
  sessionStorage.removeItem(key);
}

export function clearCache() {
  sessionStorage.clear();
}
